import React from "react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

const cn = (...inputs) => twMerge(clsx(inputs));

const WhiteBgCard = ({ children, className = "" }) => {
  return (
    <div
      className={cn(
        "bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-800 p-6 shadow-xs",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default WhiteBgCard;
